export enum PushNotificationType {
    COMPONENT_VALUE_UPDATE="COMPONENT_VALUE_UPDATE"
}